module.exports = __webpack_public_path__ + "img/logo-hotelv-fizeaustraat--dark.b60e239bb6344b1ebe42e43e3d2622b1.svg";